import React, { Component } from 'react';
import ModalEstudo from '../../aluno/trilha/ModalEstudo';
import CollapsablePanel from '../../CollapsablePanel';
import Filtro from './Filtro';
import { Subscribe } from 'unstated'
import UserContainer from '../../../containers/user.container'
import { PracticeTestContainer } from '../../../containers/practiceTest.container'
import Loading from '../../Loading';
import * as correcaoRequest from '../../../requests/correcao.request'
import { STUDY_STATUS } from '../../../const';

class CorrecaoAtividades extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
            loadingGeral: false,
            showModalConteudo: false,
            filtros: {},
            listaAtividades: [],
            itemSelecionado: {},
        }

        this.onClickCorrigir = this.onClickCorrigir.bind(this);
        this.closeModalConteudo = this.closeModalConteudo.bind(this);
        this.onClickAplicarFiltros = this.onClickAplicarFiltros.bind(this);
        this.handleWindowSizeChange = this.handleWindowSizeChange.bind(this)
    }

    componentDidMount() {
        // console.log('userContainer',this.props.userContainer);
        // console.log('practiceTestContainer',this.props.practiceTestContainer);
        if(Object.keys(this.props.userContainer.state.selectedSchool).length>0 || Object.keys(this.props.userContainer.state.selectedGrade).length>0 ) {
            // console.log('set filtros');
            // console.log('filtros', this.state.filtros);
            this.setState({ filtros: { ...this.state.filtros, selectedSchool: this.props.userContainer.state.selectedSchool, selectedGrade: this.props.userContainer.state.selectedGrade.idGrade }}, () => {
                // console.log('after state filtros', this.state.filtros);
            } );
        }

    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
        this.isUnmounted = true
    }
    handleWindowSizeChange() {
        this.setState({ width: window.innerWidth });
    }


    onClickCorrigir(item) {
        this.setState({ showModalConteudo: true, itemSelecionado: item });
    }

    closeModalConteudo(mudou) {

        this.setState({ showModalConteudo: false });

        if(mudou){
            this.popularAtividades();
        }
    }

    async onClickAplicarFiltros(filtros) {

        await this.setState({ filtros: filtros });

        this.popularAtividades();
    }

    async popularAtividades() {
        this.setState({ loadingGeral: true });


        var lstAtividades = await correcaoRequest.getListaAtividades(
            this.state.filtros.serieSelecionada,
            this.state.filtros.periodoSelecionado,
            this.state.filtros.simuladoSelecionado,
            this.state.filtros.turmasSelecionadas,
            this.state.filtros.alunoSelecionado);

        console.log(lstAtividades);
        this.setState({ loadingGeral: false, listaAtividades: lstAtividades || [] });
    }


    render() {
        const isMobile = this.state.width <= 768;
        // console.log('this.state.filtros',this.state.filtros)

        return (<div>



            <CollapsablePanel
                openText="Filtro"
                closeText="Filtro"
                isCollapsed={isMobile}
                panelContent={<Filtro isMobile={isMobile} selected={this.state.filtros} onClickAplicar={this.onClickAplicarFiltros} />}
                mainContent={<div className="edb-padding-left edb-margin-top edb-padding-top">
                    {this.state.filtros.serieSelecionada && this.state.loadingGeral && <Loading />}

                    {/******** EmptyState Lista de atividades (Selecionar filtro) ********/}
                    { !this.state.filtros.serieSelecionada && <div className="edb-padding">

                        <div className="edb-row edb-hide-small">
                            <h3 className="edb-text-bold">Lista de atividades para corrigir</h3>
                            <p>Utilize o <strong>filtro</strong> para selecionar uma série/ano para continuar.</p>
                        </div>
                        <div className="edb-row edb-hide-medium edb-hide-large">
                            <div className="edb-col edb-center">
                                <h3 className="edb-text-bold">Lista de atividades para corrigir</h3>
                                <p>Utilize o <strong>filtro</strong> para selecionar uma série/ano para continuar</p>
                            </div>
                        </div>
                    </div>}

                    {/******** EmptyState Lista de atividades (Nenhum item) ********/}
                    { this.state.filtros.serieSelecionada && !this.state.loadingGeral && this.state.listaAtividades.length === 0 &&
                        <div className="edb-margin-top edb-padding">
                            <h3 className="edb-text-bold">Lista de atividades para corrigir</h3>
                            <p>Nenhuma atividade encontrada para o filtro selecionado.</p>
                    </div>}

                    {this.state.filtros.serieSelecionada && !this.state.loadingGeral && this.state.listaAtividades.length > 0 && <div className="edb-margin-top edb-padding">
                        <h3 className="edb-text-bold">Lista de atividades para corrigir</h3>
                        <table className="edb-table edb-round-large edb-bordered adap-white edb-striped edb-margin-top">
                            <thead className="edb-hide-small">
                                <tr>
                                    <th><i className="far fa-user edb-margin-small-right"></i>Aluno</th>
                                    <th><i className="fas fa-users edb-margin-small-right"></i>Turma</th>
                                    <th><i className="fas fa-pencil-alt edb-margin-small-right"></i>Atividade</th>
                                    <th><i className="fas fa-graduation-cap edb-margin-small-right"></i>Disciplina</th>
                                    <th><i className="fas fa-tasks edb-margin-small-right"></i>Status</th>
                                    <th><i className="far fa-check-circle edb-margin-small-right"></i>Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                            {this.state.listaAtividades && this.state.listaAtividades.map((item, index) =>

                                <tr key={`item-atividade-${index}`} >
                                    <td className="edb-block-mobile">
                                        <div className="edb-hide-medium edb-hide-large edb-margin-small-right edb-margin-small-bottom edb-left">
                                            <i className="far fa-user edb-margin-small-right"></i>
                                            <span className="edb-text-bold">Aluno</span>
                                        </div>
                                        {item.inStatusStudy === STUDY_STATUS.CORRIGIDO.toString() ?
                                            <i className="fas fa-circle adap-text-green edb-margin-small-right"></i>
                                            : <i className="fas fa-circle adap-text-red edb-margin-small-right"></i>}
                                        <span>{item.txScreenname}</span>
                                    </td>
                                    <td className="edb-block-mobile">
                                        <div className="edb-hide-medium edb-hide-large edb-margin-small-right edb-margin-small-bottom edb-left">
                                            <i className="fas fa-users edb-margin-small-right"></i>
                                            <span className="edb-text-bold">Turma</span>
                                        </div>
                                        {item.txClass}
                                    </td>
                                    <td className="edb-block-mobile">
                                        <div className="edb-hide-medium edb-hide-large edb-margin-small-right edb-margin-small-bottom edb-left">
                                            <i className="fas fa-pencil-alt edb-margin-small-right"></i>
                                            <span className="edb-text-bold">Atividade</span>
                                        </div>
                                        {item.txStudy}
                                    </td>
                                    <td className="edb-block-mobile">
                                        <div className="edb-hide-medium edb-hide-large edb-margin-small-right edb-margin-small-bottom edb-left">
                                            <i className="fas fa-graduation-cap edb-margin-small-right"></i>
                                            <span className="edb-text-bold">Disciplina</span>
                                        </div>
                                        {item.disciplines}
                                    </td>
                                    <td className="edb-block-mobile">
                                        <div className="edb-hide-medium edb-hide-large edb-margin-small-right edb-margin-small-bottom edb-left">
                                            <i className="fas fa-tasks edb-margin-small-right"></i>
                                            <span className="edb-text-bold">Status</span>
                                        </div>
                                        <div className="edb-left-align">
                                            {item.txStatusStudy}
                                        </div>
                                    </td>
                                    <td className="edb-block-mobile">
                                        <div className="edb-hide-medium edb-hide-large edb-margin-small-right edb-margin-small-bottom edb-left">
                                            <i className="far fa-check-circle edb-margin-small-right"></i>
                                            <span className="edb-text-bold">Ação</span>
                                        </div>
                                        <div className="edb-btn-link adap-text-green edb-text-bold" onClick={() => this.onClickCorrigir(item)}>
                                            {item.inStatusStudy === STUDY_STATUS.CORRIGIDO.toString() ?
                                                <span>Editar correção</span>
                                                : <span>Corrigir</span>}
                                        </div>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                        </div>
                    }
                </div>}
            />

            <ModalEstudo
                isOpen={this.state.showModalConteudo}
                onCloseModal={this.closeModalConteudo}
                idEstudo={this.state.itemSelecionado.idStudentStudy}
                idUserStudent={this.state.itemSelecionado.idUser}
                idAccount={this.state.itemSelecionado.idAccount}
                correcao={true} />

        </div>);
    }
}

export default (props) => (<Subscribe to={[UserContainer, PracticeTestContainer]}>
    {(user, simulado) => <CorrecaoAtividades {...props} userContainer={user} practiceTestContainer={simulado} />}
</Subscribe>);
